module.exports = __webpack_public_path__ + "static/media/sx.9ab0a8d4.svg";